<template>
  <div class="page-wrapper support-container">
    <!--Contact us Modal -->
    <div
      id="support-modal"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      v-bind:class="{ show: isOpen }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div
          v-if="isOpen"
          class="modal-content"
          v-click-outside="closeModal"
          id="modal"
        >
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3 mb-0 text-center card-head"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("supportModal.contactUs") }}
            </h5>

            <div
              class="modal-card d-flex mb-5 cursor-pointer"
              @click="openEmail()"
            >
              <div style="flex-grow:2; align-self:center">
                <IconAt />
              </div>
              <div class="d-block" style="flex-grow:2">
                <h5>{{ $t("supportModal.sendEmail") }}</h5>
                <p>{{ $t("supportModal.getResponseWithinHour") }}</p>
              </div>
            </div>
            <div
              @click="opentidio()"
              class="modal-card d-flex mb-5 chat-button cursor-pointer"
            >
              <div style="flex-grow:2; align-self:center">
                <IconBubble />
              </div>
              <div class="d-block" style="flex-grow:2">
                <h5>{{ $t("supportModal.chatWithUs") }}</h5>
                <p>{{ $t("supportModal.getResponseImmediately") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Suggestion Modal -->
    <div
      id="addalarm"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      v-bind:class="{ show: isOpen2 }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered align-items-center d-flex justify-content-center"
      >
        <div
          v-if="isOpen2"
          class="modal-content"
          style="max-height:90vh"
          v-click-outside="closeModal2"
          id="modal"
        >
          <div class="card-body p-0">
            <h5
              class="mx-0 px-2 pb-4 mb-0 card-head text-center pt-4"
              style="font-weight:500"
            >
              {{ $t("suggestionModal.suggestImprovement") }}
            </h5>
            <form class="" @submit.prevent="doSubmitSuggestion">
              <div class="card-body mb-3 card-btm-border">
                <p class="p-2 gray6" style="font-size: 1rem;">
                  {{ $t("suggestionModal.helpWith") }}
                </p>

                <div class="form-group">
                  <label for="">{{
                    $t("suggestionModal.productCategory")
                  }}</label>
                  <select
                    v-model="productVal"
                    name="device"
                    class="form-control"
                    required
                  >
                    <option value="" selected
                      >--{{ $t("suggestionModal.choose") }}--</option
                    >
                    <option
                      v-for="(category, i) in categories"
                      :key="i"
                      :value="category.value"
                      >{{ category.name }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="">{{ $t("suggestionModal.urgency") }}</label>
                  <select
                    v-model="urgency"
                    name="device"
                    class="form-control"
                    required
                  >
                    <option value="" selected
                      >--{{ $t("suggestionModal.choose") }}--</option
                    >
                    <option
                      v-for="(urgency, i) in urgencyList"
                      :key="i"
                      :value="urgency.value"
                      >{{ urgency.name }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="gray6">{{ $t("suggestionModal.title") }}</label>
                  <input
                    type="text"
                    name="title"
                    v-model="title"
                    class="form-control"
                    required
                    :placeholder="$t('suggestionModal.title')"
                  />
                </div>
                <div class="form-group">
                  <label class="gray6">{{
                    $t("suggestionModal.description")
                  }}</label>
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    name="description"
                    v-model="sug_description"
                    rows="5"
                    required
                  ></textarea>
                </div>
              </div>
              <div
                class="form-group px-3 py-1 justify-content-between"
                style="display:flex;"
              >
                <button
                  @click="closeModal2"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("suggestionModal.cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ $t("suggestionModal.send") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Email PopUp Modal -->
    <div>
      <div
        id="addalarm"
        class="modal fade"
        style="background: rgba(0,0,0,0.5)"
        v-bind:class="{ show: isOpen3 }"
        tabindex="-1"
        role="dialog"
        aria-labelledby="vcenter"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered side align-items-end d-flex justify-content-end"
        >
          <div
            v-if="isOpen3"
            class="modal-content email"
            v-click-outside="closeModal3"
            id="modal"
          >
            <div class="card-body p-0">
              <h5
                class="mx-0 px-2 pb-4 mb-0 card-head text-center pt-4 text-white"
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); background-color: #213e7a;font-weight:500"
              >
                {{ $t("emailModal.leaveMessage") }}
                <i
                  class="fas fa-minus position-absolute cursor-pointer"
                  style="right: 2rem;top:28px"
                  @click="closeModal3"
                ></i>
              </h5>
              <form class="" @submit.prevent="submitEmail">
                <div class="card-body mb-3 card-btm-border">
                  <p class="p-2 gray6" style="font-size: 1rem;">
                    {{ $t("emailModal.whatDoYouNeedHelpWith") }}
                  </p>

                  <div class="form-group">
                    <label class="gray6">{{
                      $t("emailModal.emailAddress")
                    }}</label>
                    <input
                      type="email"
                      name="email"
                      v-model="email"
                      class="form-control"
                      required
                      :placeholder="$t('emailModal.emailAddressPlaceholder')"
                    />
                  </div>
                  <div class="form-group">
                    <label class="gray6">{{ $t("emailModal.subject") }}</label>
                    <input
                      type="text"
                      name="subject"
                      v-model="subject"
                      class="form-control"
                      required
                      :placeholder="$t('emailModal.subjectPlaceholder')"
                    />
                  </div>
                  <div class="form-group">
                    <label class="gray6">{{
                      $t("emailModal.description")
                    }}</label>
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      name="description"
                      v-model="description"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                </div>
                <div
                  class="form-group px-3 py-1"
                  style="display:flex; justify-content: end"
                >
                  <button type="submit" class="btn btn-primary">
                    {{ $t("emailModal.send") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="page-wrapper support-container"> -->
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <h4 class="mb-5">
      {{ $t("support") }}
    </h4>
    <div class="notif-box">
      <NotifcationBox v-if="showNotif" :mssg="mssg" :errorMssg="Errormssg" />
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12 col-lg-4 col-xl-3">
        <div class="card">
          <div class="circle">
            <span>
              <IconSearch />
            </span>
          </div>
          <p class="title">{{ $t("search-help-desk") }}</p>
          <p class="content-text">
            {{ $t("get-quick-answers") }}
          </p>
          <button>
            <a href="https://support.gricd.com" target="_blank" class="pb-3">{{
              $t("find-answers")
            }}</a>
          </button>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12 col-lg-4 col-xl-3">
        <div class="card">
          <div class="circle">
            <span>
              <IconComment />
            </span>
          </div>
          <p class="title">{{ $t("get-in-touch") }}</p>
          <p class="content-text">
            {{ $t("send-message-chat") }}
          </p>
          <button @click="isOpen = !isOpen">{{ $t("contact-us") }}</button>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12 col-lg-4 col-xl-3">
        <div class="card">
          <div class="circle">
            <span>
              <IconGitPull />
            </span>
          </div>
          <p class="title">{{ $t("dashboard-tour") }}</p>
          <p class="content-text">
            {{ $t("learn-features") }}
          </p>
          <button class="" @click="startIntroJs">{{ $t("start") }}</button>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12 col-lg-4 col-xl-3">
        <div class="card">
          <div class="circle">
            <span>
              <IconSupportArrow />
            </span>
          </div>
          <p class="title">{{ $t("suggest-improvement") }}</p>
          <p class="content-text">
            {{ $t("spot-something") }}
          </p>
          <button class="" @click="isOpen2 = !isOpen2">
            {{ $t("make-suggestion") }}
          </button>
        </div>
      </div>
    </div>

    <!-- </div> -->
  </div>
</template>

<script>
import IconSearch from "../../components/Iconsvg/IconSearch.vue";
import IconComment from "../../components/Iconsvg/IconComment.vue";
import IconSupportArrow from "../../components/Iconsvg/IconSupportArrow.vue";
import IconGitPull from "../../components/Iconsvg/IconGitpull.vue";
import IconAt from "../../components/Iconsvg/Icon@.vue";
import IconBubble from "../../components/Iconsvg/IconChatBubble.vue";
import introJs from "intro.js";
// import "intro.js/introjs.css";
import "intro.js/minified/introjs.min.css";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import NotifcationBox from "../../components/NotificationBox.vue";
export default {
  name: "Support",
  components: {
    IconSearch,
    IconComment,
    IconSupportArrow,
    IconGitPull,
    IconAt,
    IconBubble,
    Loading,
    NotifcationBox,
  },
  data() {
    return {
      isOpen: false,
      isOpen2: false,
      isOpen3: false,
      isLoading: false,
      fullPage: false,
      categories: [
        { name: "Dashboard", value: "dashboard" },
        { name: "My Devices", value: "devices" },
        { name: "Groups", value: "groups" },
        { name: "Live Maps", value: "live_maps" },
        { name: "Records", value: "records" },
        { name: "Reports", value: "reports" },
        { name: "Alarms", value: "alarms" },
        { name: "Wallets", value: "wallets" },
        { name: "Users", value: "users" },
        { name: "Others", value: "others" },
      ],
      urgencyList: [
        { name: "Nice to have", value: "nice_to_have" },
        { name: "Important", value: "important" },
        { name: "Critical", value: "critical" },
      ],
      productVal: "",
      title: "",
      urgency: "",
      sug_description: "",
      email: "",
      subject: "",
      description: "",
      mssg: "",
      Errormssg: "",
      showNotif: false,
    };
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["submitSupportEmail", "submitSuggestion"]),
    closeModal() {
      this.isOpen = false;
    },
    closeModal2() {
      this.isOpen2 = false;
      this.productVal = "";
      this.urgency = "";
      this.sug_description = "";
      this.title = "";
    },
    closeModal3() {
      this.isOpen3 = false;
      window.fcWidget.show();
      this.email = "";
      this.email = "";
      this.description = "";
      this.subject = "";
    },
    opentidio() {
      window.fcWidget.open();
    },
    startIntroJs() {
      // introJs()
      //   .setOptions({
      //     tooltipClass: "customTooltip",
      //     showStepNumbers: false,
      //     nextLabel: "Next",
      //     tooltipPosition: "right",
      //     // skipLabel: "",
      //   })
      //   .start();
      // introJs().start();
      introJs()
        .setOptions({
          tooltipClass: "customTooltip",
          showStepNumbers: false,
          nextLabel: "Next",
          tooltipPosition: "right",
          overlayOpacity: 0.8,
          showBullets: false,
          // skipLabel: "",
        })
        .start();
    },
    openEmail() {
      this.isOpen = false;
      this.isOpen3 = true;
      window.fcWidget.hide();
    },
    submitEmail() {
      this.isLoading = true;
      const data = {
        email: this.email,
        message: this.description,
        subject: this.subject,
      };
      this.submitSupportEmail(data).then((res) => {
        this.isLoading = false;
        this.showNotif = true;
        this.closeModal3();
        this.mssg = res.data.message;
        setTimeout(() => {
          this.showNotif = false;
          this.mssg = "";
        }, 6000);
      });
    },
    doSubmitSuggestion() {
      this.isLoading = true;
      const data = {
        category: this.productVal,
        urgency: this.urgency,
        title: this.title,
        description: this.subject,
      };
      this.submitSuggestion(data).then((res) => {
        this.isLoading = false;
        this.showNotif = true;
        this.closeModal2();
        this.mssg = res.data.message;
        setTimeout(() => {
          this.showNotif = false;
          this.mssg = "";
        }, 6000);
      });
    },
  },
  // mounted() {
  //   this.startIntroJs();
  // },
  beforeRouteLeave(to, from, next) {
    introJs().exit();
    next();
  },
};
</script>
<style src="../../assets/css/style.css"></style>
<style scoped>
.support-container {
  height: 100vh;
  padding: 12rem 3rem 3rem !important;
}
.card {
  background: #ffffff;
  border: 1px solid #e1e7ec;
  box-sizing: border-box;
  border-radius: 5px;
  height: 25rem;
  /* width: 100%; */
  width: calc(100% - 2rem);
  display: flex;
  justify-content: space-between;
  padding: 4rem 2rem 2rem;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}
.card button {
  background: #ffffff;
  border: 1px solid #b7c3cd;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Sarabun;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 140.62%;
  text-align: center;
  color: #404a57;
  padding: 1rem;
  width: calc(100% - 2rem);
}
.card button:hover {
  background: #ffffff;
  border: 1px solid #213e7a;
  color: #213e7a;
}
.card button:focus {
  background: #ffffff;
  border: 1px solid #213e7a !important;
  color: #213e7a;
  outline: #213e7a;
}
.card p {
  text-align: center;
}
.card .title {
  font-family: Sarabun;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 140.62%;
  color: #404a57;
  position: relative;
  top: 1rem;
}
.card .circle {
  background-color: #dee2eb;
  mix-blend-mode: normal;
  border-radius: 30px;
  height: 4rem;
  width: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.card .content-text {
  font-family: Sarabun;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 140.62%;
  text-align: center;
  color: #5e6a79;
}
h4 {
  font-family: Sarabun;
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 140.62%;
  color: #404a57;
  text-align: center;
}
.card a {
  color: #404a57;
}
.card button:hover a {
  color: #213e7a;
}
.modal-card {
  padding: 1.5rem 2rem;
  width: calc(100% - 3rem);
  border: 1px solid #e1e7ec;
  box-sizing: border-box;
  border-radius: 15px;
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}
.modal-content {
  width: 75%;
}
.modal-card h5 {
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 26px;
  color: #404a57;
}
.modal-card p {
  font-weight: normal;
  font-size: 16px;
  line-height: 140.62%;
  color: #8693a5;
  margin-bottom: 0;
}
.card-head {
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 26px;
  color: #222222;
}
.introjs-nextbutton {
  background: red !important;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 5px;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
.side {
  margin-left: auto !important;
  margin-right: 1rem !important;
  margin-top: auto;
}
.card-btm-border {
  border-bottom: 0.4px solid rgba(99, 99, 99, 0.5);
  box-sizing: border-box;
  box-shadow: 4px 0px 0px 2px rgba(0, 0, 0, 0.05);
  border-radius: 0px 0px 5px 5px;
}
.modal-content.email {
  max-height: 100%;
}
.notif-box {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 768px) {
  .notif-box {
    width: 100%;
  }
  .modal-card {
    display: block !important;
  }
  .modal-content {
    width: 100%;
  }
}
@media (max-width: 1440px) and (min-width: 900px) {
  .modal-content {
    width: 100% !important;
  }
}
</style>
